import { MainLayout } from 'Components/Layouts'
import { SuspenseUI } from 'Components/UI'
import { SchoolPath } from 'Constants/Navigation'
import { $Account } from 'Models'
import { useStore } from 'effector-react'
import { Navigate } from 'react-router-dom'
import { isSchoolAccount } from 'Utils/AccountRole'

const DefaultRedirect = () => {
  const account = useStore($Account)

  return <Navigate to={isSchoolAccount(account) ? `/${SchoolPath.main}/${SchoolPath.announcements}` : '/main/banner'} replace />
}

export const baseRoutes = {
  path: '',
  children: [
    {
      path: '/',
      element: <MainLayout />,
      children: [
        {
          path: '',
          element: <DefaultRedirect />,
        },
        // {
        //   path: 'uikit',
        //   element: (
        //     <SuspenseUI>
        //       <UIKitPage />
        //     </SuspenseUI>
        //   ),
        // },
        {
          path: '404',
          element: <SuspenseUI>404</SuspenseUI>,
        },
      ],
    },
    {
      path: '*',
      element: <Navigate to='/404' />,
    },
  ],
}
